import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import styles from './styles.module.scss';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

export interface IPagination {
  pagination?: {
    actualPage?: number,
    totalPages?: number,
    limit?: number,
    pagesArray?: number[],
    page_number: number | 0,
    total_pages: number | 0,
    records_pages: number | 0,
    total_records: number | 0
  };
  updatePage: (page: number) => void;
}

export interface IPag {
  actualPage?: number,
  totalPages?: number,
  limit?: number,
  pagesArray?: number[]
  page_number: number,
  total_pages: number,
  records_pages: number,
  total_records: number
}

const Pagination: React.FC<IPagination> = ({pagination, updatePage}) => {
  const { t } = useTranslation();
  return(
    <div className='d-flex w-100 align-items-center justify-content-between'>
        <span>{t('PAGINATION.SHOW')} {(pagination?.total_records !== 0 ? pagination?.actualPage*pagination?.limit+1 : 0) || 0} {t('PAGINATION.TO')} {(pagination?.total_records >= pagination?.records_pages ? (pagination?.records_pages*(pagination?.actualPage+1)) : pagination?.total_records) || 0} {t('PAGINATION.OF')} {pagination?.total_records || 0}</span>
          <div className='d-flex align-items-center justify-content-end'>
              <ul className='pagination'>
                  <li
                    className='page-item'
                  >
                    <button
                      className={`${styles.paginationNextPreviousLink}`}
                      style={{cursor: 'pointer'}}
                      onClick={async() => {
                        if(pagination?.actualPage!-1 >= 0) {
                          await updatePage(pagination?.actualPage!-1)
                        }
                      }}
                      disabled={pagination?.actualPage!-1 >= 0 ? false : true}
                    >
                      Anterior
                    </button>
                  </li>
                  {pagination?.pagesArray?.map((page, index) => (
                    page <= pagination.actualPage!+5 && page >= pagination.actualPage!-5 &&(
                      <li
                        key={index}
                        className='page-item'
                      >
                        <button
                          className={clsx(`${styles.paginationLink}`,
                          {
                            [styles.paginationLinkActive]: pagination?.actualPage! === page
                          })}
                          onClick={async() => {
                            if(pagination.actualPage === page) return;
                            await updatePage(page)
                          }}
                          style={{cursor: 'pointer'}}
                        >
                          {page+1}
                        </button>
                      </li>
                    )
                    ))}
                  <li
                    className='page-item'
                  >
                    <button
                      className={`${styles.paginationNextPreviousLink}`}
                      style={{cursor: 'pointer'}}
                      onClick={async() => {
                        if(pagination?.actualPage!+1 <= pagination?.totalPages!) {
                          await updatePage(pagination?.actualPage!+1)
                        }
                      }}
                      disabled={pagination?.actualPage!+1 <= pagination?.totalPages!-1 ? false : true}
                    >
                      Proximo
                    </button>
                  </li>
              </ul>
          </div>
      </div>
  );
}

export default Pagination;